import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from '~/components/Steps/Photos/PhotoLayout';

export function FrontPassengersideAngle() {
  return <PhotoLayout {...photoLayoutConfig['frontPassengersideAngle']} />;
}
